/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Flex, Box, Text, useBreakpointIndex } from '@tishman/components';
import React from 'react';

import RoxyBannerImage from '../images/RoxyBanner.png';

export interface RoxyBannerProps {
  text: string;
}

const styles = {
  RoxyBannerBox: {
    backgroundColor: 'heroBackground',
    border: '1px solid #A88362',
    width: '100%',
    maxWidth: 1040,
    margin: '80px auto',
  },
  RoxyTipText: {
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '2px',
    marginBottom: '5px',
  },
  RoxyContentText: { fontWeight: 500, fontSize: '32px', lineHeight: '33px' },
};

const RoxyBanner = ({ text }: RoxyBannerProps): React.JSX.Element | null => {
  const isMobile = useBreakpointIndex() < 2;
  return (
    <Box sx={styles.RoxyBannerBox}>
      <Flex
        sx={{
          margin: ['24px 44px', '14px 66px'],
          alignItems: 'center',
          flexDirection: ['column', 'row'],
        }}
      >
        <img
          alt="Roxy the owl"
          src={RoxyBannerImage}
          style={{
            width: 64,
            height: 114,
            marginBottom: isMobile ? 20 : 0,
          }}
        />
        <Flex sx={{ flexDirection: ['column'], marginLeft: [0, 64] }}>
          <Text sx={styles.RoxyTipText}>ROXY&apos;S TIP:</Text>
          <Text sx={styles.RoxyContentText}>{text}</Text>
        </Flex>
      </Flex>
    </Box>
  );
};

export default RoxyBanner;
